import React from "react";
import "./About.css";

export const About = (props) => (
  <div className="background">
    <div className="members-div">
      <div>
        <h2 className="heading">A Project By</h2>

        <div className="aibas-card-border">
          <div className="aibas-card">
            <p className="department-name">AIBAS Department</p>
            <p>Amisha Dusane</p>
            <p>Tanya Rodriguez</p>
            <p>Komal Nanaware</p>
            <p>R. Gayathri</p>
            <p>Maitri Patel</p>
          </div>
        </div>
        <div className="aset-card-border">
          <div className="aset-card">
            <p className="department-name">ASET Department</p>
            <p>Neel Parihar</p>
            <p>Saurabh Shukla</p>
            <p>Sejal Tiwari</p>
            <p>Priyanshi Chaturvedi</p>
            <p>Simran Singh Chauhan</p>
          </div>
        </div>
      </div>
    </div>
  </div>
);
